<template>
  <div class="confirm">
    <h1 class="h1 title">{{$t('contact.confirm_title')}}</h1>
    <div class="lead white-space-pre-wrap">{{ $t('contact.confirm_lead') }}</div>
    <form class="text-left" @submit.prevent="submitContactConfirm">

      <!-- <label>{{$t('contact.company')}}</label>
      <p>{{form.organization_name}}</p> -->

      <label v-html="$t('contact.name')"></label>
      <p>{{form.name}}</p>


      <label v-html="$t('contact.mail')"></label>
      <p>{{form.email}}</p>


      <div v-if="form.user_id" class="app_user">
        <label v-html="$t('contact.user_id')"></label>
        <p>{{form.user_id}}</p>
      </div>


      <div v-if="form.user_name" class="app_user">
        <label v-html="$t('contact.user')"></label>
        <p>{{form.user_name}}</p>
      </div>

      <!-- <label v-html="$t('contact.topic')"></label>
      <p>{{form.title}}</p> -->

      <label v-html="$t('contact.detail')"></label>
      <p>{{form.detail}}</p>
      <div class="bottom d-flex justify-content-center">
        <div class="btn-wrapper text-center">
          <button class="btn back mr-17 position-relative" type="button" @click="backPage">{{$t('btn.back_confirm')}}<span class="arrows arrows-second border-black ml-7"></span></button>
        </div>
        <div class="btn-wrapper text-center">
          <button class="btn send btn-red position-relative" type="submit" :class="{disabled: disableBtn}" @click="disabled()">{{$t('btn.send_mail')}}<span class="arrows arrows-first arrows-right border-white ml-7"></span></button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios'
  import FormData from 'form-data'
  import { mapGetters } from 'vuex'
  import { META_CONTACT } from '../../mixins/metadata.js'
  import CONTACT_FORM from '../../mixins/contactForm.js'
  import { success, error } from '../../utils/toastr.js'
  import i18n from '../../locales/i18n.js'

  export default {
    mixins: [META_CONTACT, CONTACT_FORM],
    name: 'ContactConfirm',
    data() {
      return {
        isLoading: false,
        form: {
          organization_name: null,
          name: null,
          user: null,
          email: null,
          title: null,
          detail: null,
          user_id:null,
          user_name:null,
        },
        disableBtn: false,
      }
    },

    computed: {
      ...mapGetters('contact', ['use_app']),
      contactDataStored() {
        const data = localStorage.getItem('contactData')
        const dataObj = JSON.parse(data)
        return _.omit(dataObj, ['tmpInquiry'])
      }
    },

    mounted() {
      // 配列フォームの中身がからであれば
      if (_.isEmpty(this.contactDataStored)) {
        this.$router.push({ name: 'contact.index' })
      }
      // 配列フォームの中身をなにかする
      this.updateFormData(this.contactDataStored)
    },

    methods: {
      // 戻る
      backPage() {
        this.$router.push({ name: 'contact.index' })
      },
      // 配列フォームの中身をdataで受け取って
      updateFormData(data) {
        // dataにいれる（↓このマージについてはよくわからん。lodashの機能かな）
        this.form = _.merge(this.form, data)
      },
      // 送信するかエラーで戻すかする。
      async submitContactConfirm() {
        try {
          // ローディングアイコン表示する。
          this.$set(this, 'isLoading', true)
          // postする
          // await ContactService.store(this.form)
          await this.sendContactDetail(this.form)
          // ローディングアイコンを消す
          this.$set(this, 'isLoading', false)
          // 成功送信が成功しました。
          success(i18n.t('msg.send_success'))
          // ローカルストレージを削除する
          localStorage.removeItem(this.LOCAL_STORAGE_KEY)
          // 完了ページヘ遷移する。
          this.$router.push({ name: 'contact.success' })
        } catch (e) {
          // ローディングアイコンを消す
          this.$set(this, 'isLoading', false)
          // 何か問題が発生しています。再度ご確認ください。
          error(i18n.t('msg.some_thing_went_wrong'))
        }
      },
      // ココに書く
      async sendContactDetail() {
        const data = new FormData()
        data.append('your-subject', this.form.title)
        data.append('company', this.form.organization_name)
        data.append('your-name', this.form.name)
        data.append('your-user', this.form.user)
        data.append('your-email', this.form.email)
        data.append('menu-title', this.form.title)
        data.append('your-message', this.form.detail)
        data.append('user_id', this.form.user_id)
        data.append('user_name', this.form.user_name)

        const config = {
          method: 'post',
          url: process.env.VUE_APP_WP_API_FORM,
          // url: 'https://stg.zatsudan-work.net/zatsudan_adminconsole/wp-json/contact-form-7/v1/contact-forms/5/feedback',
          headers: {
            'Content-Type': 'multipart/form-data',
            // 'Authorization': 'Basic emF0c3VkYW4tc3RnLWJhc2ljYXV0aDpFZm45cVNCOURUMUhXOUluRmMzcw==',
            'Authorization': process.env.VUE_APP_WP_API_AUTH,
          },
          data
        }
        await axios(config)
        .then((response) => {
          //console.log(JSON.stringify(response.data))
        })
        .catch((e) => {
          //console.log(e)
        })
      },
      disabled() {
        this.disableBtn = true
      }
    }
  }
</script>
